import { render, staticRenderFns } from "./addCus.vue?vue&type=template&id=d2fb66ce&scoped=true"
import script from "./addCus.vue?vue&type=script&lang=js"
export * from "./addCus.vue?vue&type=script&lang=js"
import style0 from "./addCus.vue?vue&type=style&index=0&id=d2fb66ce&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fb66ce",
  null
  
)

export default component.exports